export default __webpack_public_path__ + "static/media/Ring.4bf0702d.wav";